<template>
  <footer>
    <div class="fbet">
      <div class="left">
        <h3>START A project with us TODAY!</h3>
        <p>
          Our capability and high-impact service quality have benefited many.
        </p>
      </div>
      <div class="right">
        <router-link to="/book" class="btn">BOOK AN APPOINTMENT</router-link>
      </div>
    </div>
    <div class="fbet mobile">
      <div class="left">
        <p>Rubii Fitness andGym Equipment</p>
        <p>© 2023 All Rights Reserved</p>
      </div>
      <div class="right">
        <div class="innerf">
          <div class="left">
            <p>info@rubiifitness.com</p>
            <p>+91 98900 98900</p>
          </div>
          <div class="right">
            <a href="https://facebook.com/" target="_blank"> Facebook </a><br />
            <a href="https://instagram.com/" target="_blank"> Instagram </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
footer {
  padding: 0 5%;
  width: 100%;
}

footer .fbet {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 3% 0;
  border-bottom: 2px solid var(--border);
}

footer .fbet .left {
  width: 75%;
}

footer .fbet .left h3 {
  font-size: 1.5rem;
  font-weight: 500;
  color: var(--text);
  text-transform: uppercase;
  margin-bottom: 1rem;
}

footer .fbet .right {
  width: 25%;
}

footer .fbet .right a.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--red);
  text-decoration: none;
  border: 1px solid var(--border);
  width: 100%;
  height: 3rem;
  font-size: 1rem;
}

footer .fbet .right a.btn:hover {
  background-color: var(--red);
  color: white;
}

footer .fbet .right .innerf {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
footer .fbet .right .innerf p,
footer .fbet .right .innerf a {
  font-size: 1rem;
  font-weight: 400;
  color: var(--text);
  margin-bottom: 0.5rem;
}

footer .fbet .right .innerf .left {
  width: 70%;
}

footer .fbet .right .innerf .right {
  width: 30%;
}

footer .fbet .right .innerf .right a {
  color: var(--text);
  text-decoration: none;
  font-size: 1rem;
  float: right;
}

footer .fbet .right .innerf .right a:hover {
  color: var(--red);
}

@media screen and (max-width: 768px) {
  footer .fbet {
    flex-direction: column;
    align-items: flex-start;
  }

  footer .fbet.mobile {
    flex-direction: column-reverse;
  }

  footer .fbet .left {
    width: 100%;
  }

  footer .fbet .right {
    width: 100%;
  }

  footer .fbet .right a.btn {
    width: 100%;
    margin: 1rem 0;
  }

  footer .fbet .right .innerf {
    flex-direction: column;
    align-items: flex-start;
  }

  footer .fbet .right .innerf .left {
    width: 100%;
  }

  footer .fbet .right .innerf .right {
    width: 100%;
    float: left;
  }

  footer .fbet .right .innerf .right a {
    width: 100%;
  }
}
</style>
